{
  "create": {
    "button": "Create",
    "items": {
      "organization": "Organization",
      "project": "Project"
    },
    "no_permissions": "You do not have permissions to create projects or services."
  },
  "profile": {
    "organizations": "Organizations",
    "projects": "Projects",
    "my_profile": "My profile",
    "logout": "Logout"
  },
  "navigation": {
    "no_organizations": "You have no organizations.",
    "no_projects": "This organization does not have any projects.",
    "no_projects_in_organization": "This organization does not have any projects.",
    "no_clusters_in_project": "This project does not have any clusters.",
    "help": "Help",
    "admin": "Settings",
    "documentation": "Documentation",
    "support": "Support",
    "setup": "Setup"
  },
  "footer": {
    "copyright": "© 2000–{{currentYear}} CYBERTEC PostgreSQL International GmbH",
    "about": "About",
    "imprint": "Imprint"
  },
  "not_found": {
    "code_descriptions": {
      "404": "Page not found",
      "403": "Forbidden"
    },
    "take_me_back": "Take me back"
  },
  "maintenance": {
    "title": "Maintenance",
    "subtitle": "Oops...",
    "description": "It seems like something went wrong, the API is unreachable.",
    "contact_line": "Please contact the responsible administrator to resolve this issue."
  },
  "page": {
    "home": "Home"
  },
  "notifications": {
    "no_notifications": "You don't have any notifications",
    "labels": {
      "status_dd": "Status:",
      "accept": "Accept",
      "decline": "Decline",
      "mute": "Mute",
      "mark_all_as_read": "Mark all as read",
      "see_more": "See more",
      "see_less": "See less"
    },
    "templates": {
      "user_added_you_to_project": "{{user}} added you to project",
      "user_removed_you_from_project": "{{user}} removed you from project",
      "user_invited_you_to_join": "{{user}} invited you to join",
      "user_removed_you_from_organization": "{{user}} removed you from organization",
      "you_have_pending_invitations": "You have pending invitations",
      "count_invitations": "{{count}} invitation",
      "count_invitations_plural": "{{count}} invitations",
      "you_invited_to_organization": "You have been invited to {{organizationName}}"
    }
  }
}
